export default __webpack_public_path__ + "static/media/blueSky3.349fcef4.png";